module.exports = __webpack_public_path__ + "img/pitching3.f9982314.png";